/* eslint-disable */
import React from 'react';
import { Switch, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { messageHandler } from './messageHandler';

import AppRoutes, { routes } from '../AppRoutes';
import WithLDUser from '../WithLDUser';
import Header from '../Header';
import SideNav from '../SideNav';

import Box from '@material-ui/core/Box';
import DisabledUser from '../DisabledUser';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useAuthenticateUser } from './useAuthenticateUser';
import { useInboxAccess } from './useInboxAccess';
import { useUpdateApiPath } from './useUpdateApiPath';
import { useInitialMsgsToExtension } from './useInitialMsgsToExtension';
import { handleTextRecruitData } from './handleTextRecruitData';
import { useAuth0, useEventMessage } from '../CustomHooks';
import { useStyles } from './styles';

export default function Root() {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const { user } = useSelector((state) => state);
	const isDisabledCustomer = user.activeAccount === 'DISABLED';

	// Initiate event-message-listener to capture messages from the extension
	useEventMessage((event) =>
		messageHandler({
			data: event.data,
			handleData: (data) => handleTextRecruitData(data, dispatch),
			user,
			dispatch
		})
	);

	useUpdateApiPath();

	const { auth0ClientInitiated } = useAuth0(user);
	const { isRefreshingToken } = useAuthenticateUser(user, auth0ClientInitiated);

	// Setup user's inboxes
	useInboxAccess(user);

	// Update extension when user is authenticated and react-app is ready
	useInitialMsgsToExtension(user);

	React.useEffect(
		() => {
			if (user.authenticated && user.textRecruitDataFromExtension) {
				history.push(routes.HOME);
			}
		},
		[user.authenticated, user.textRecruitDataFromExtension]
	);

	/**
	 * This is to prevent displaying Login component while token
	 * is refreshing.
	 */
	if (isRefreshingToken) {
		return (
			<Box display="flex" justifyContent="center" alignItems="center" height="100%">
				<CircularProgress />
			</Box>
		);
	}

	if (isDisabledCustomer) {
		return <DisabledUser />;
	}

	return (
		<Switch>
			<WithLDUser>
				<Box className={classes.root}>
					<Box className={classes.main} component="main">
						{user.authenticated && <Header history={history} />}
						<AppRoutes />
					</Box>
					<SideNav />
				</Box>
			</WithLDUser>
		</Switch>
	);
}
